var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gt-icon-legend",style:({
    background: ("url(" + _vm.iconPath + ") 0 center no-repeat"),
    'background-size': '38px'
  })},[_c('div',{staticClass:"gt-icon-legend__label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"gt-icon-legend__value"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }